import { useLang } from '@/i18n';
import gtm from 'eco-design-reliance/gtm';
import EcoNavPage from 'eco-design/sections/eco-nav-page';
import { useEffect } from 'react';
import css from './index.module.scss';

export default function FixTab() {
    const { t } = useLang('rapidseries.tab');
    const itemsA = [
        {
            title: t('rapid_pro'),
            href: '#Screen1',
        },
        {
            title: t('rapid'),
            href: '#Screen2',
        },
        {
            title: t('rapid_mag'),
            href: '#Screen3',
        },
    ];
    useEffect(() => {
        if (typeof window === 'undefined') return;
        const callback = () => {
            const screen1 = document.getElementById('Screen1');
            if (screen1) {
                const screen1Top = screen1.getBoundingClientRect().top;
                if (screen1Top <= 0) {
                    document.getElementById('NavPage')?.classList.add('active');
                } else {
                    document.getElementById('NavPage')?.classList.remove('active');
                }
            }
        };
        window.addEventListener('scroll', callback);
        return () => {
            window.removeEventListener('scroll', callback);
        };
    }, []);

    return (
        <div className={`${css.comp}`} id="NavPage">
            <EcoNavPage
                items={itemsA}
                openGTM={false}
                onClick={(item: any, index: number) => {
                    gtm.push({
                        event: 'uaEvent',
                        event_name: 'product_navigation',
                        navigation_name: item.title,
                        product_name: 'EcoFlow RAPID Series',
                    });
                }}
            />
        </div>
    );
}
